<!-- =========================================================================================
    File Name: Profile.vue
    Description: Profile Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div id="profile-page">
    <!-- PROFILE HEADER -->
    <div class="profile-header">
      <div class="relative">
        <div class="cover-container rounded-t-lg max-h-24">
          <img
            :src="match.coverImage"
            alt="user-profile-cover"
            class="responsive block"
            v-if="match.coverImage"
          />
          <img v-else :src="require('@/assets/images/match/placeholder.png')" alt="">
        </div>
      </div>
      <div class="flex items-center justify-between flex-wrap profile-header-nav p-6">
        <span class="text-lg font-medium">{{ match.title }}（{{ match.type == 1?'个人赛':'团队赛' }}）</span>
        <vs-button type="gradient" icon-pack="feather" icon="icon-arrow-right-circle" icon-after @click="goToMatchDetail(match.url)">前往赛事页面</vs-button>
      </div>
    </div>

    <!-- 进行中 -->
    <!-- TODO 下一个赛程点击事件：改变currentScheduleIndex -->
    <div class="vx-row" v-if="match.status == 3">
      <div class="vx-col w-full lg:w-3/4">
        <vx-card  class="mt-base">
          <form-wizard
            color="rgba(var(--vs-primary), 1)"
            title=""
            subtitle=""
            :startIndex="currentScheduleIndex"
            ref="wizard"
            @on-complete="formSubmitted"
          >
            <tab-content :title="itemSche.title" class="mb-5" v-for="(itemSche, index) in match.schedule" :key="index">
              <!-- tab 1 content -->

              <div v-if="!itemSche.can" class="vx-row">
                <vs-alert active="true" color="warning" icon-pack="feather" icon="icon-check-circle">你无需提交作品。</vs-alert>
              </div>
              <div v-else class="vx-row">
                <div v-if="itemSche.isUpload" class="vx-col md:w-1/2 w-full mt-5">
                  <p class="text-lg font-medium mb-4">我的作品：<span>{{ currentWork.file_name }}</span></p>
                    <div v-if="!match.isScratch">
                      <vs-input 
                        class="w-full lg:w-1/2 md:w-2/3" 
                        label="作品名称" 
                        palceholder="请输入你的作品名称" 
                        v-model="waitSubmitWork.fileName"
                        :danger="isWaitWorkTitle"
                        danger-text="作品名称不能为空喔！"
                      />
                      <upload-file :default="setReuploadFileName" :alias="waitSubmitWork.fileName" @url="getUploadResult"></upload-file>
                    </div>
                    <div v-else>
                      <div v-if="currentWork">
                        <img class="w-full mb-4 rounded" :src="currentWork.img" alt="作品封面">
                        <div class="flex">
                          <vs-button class="mr-4" icon-pack="feather" icon="icon-edit" @click="goToScratch(1)">修改作品</vs-button>
                          <vs-button color="success" icon-pack="feather" icon="icon-refresh-cw" @click="acceptReload">刷新</vs-button>
                        </div>
                      </div>
                      <div v-else class="flex">
                        <vs-button class="mr-4" icon-pack="feather" icon="icon-edit" @click="goToScratch(0)">创作作品</vs-button>
                        <vs-button color="success" icon-pack="feather" icon="icon-refresh-cw" @click="acceptReload">刷新</vs-button>
                      </div>
                    </div>
                </div>
                <div class="vx-col md:w-1/2 w-full mt-5">
                  <p class="text-lg font-medium mb-4">作品演示视频：</p>
                  <video-player v-if="currentWork.video" ref="player" class="media-video-player mb-4" :options="playerOptions(setMedia(currentWork.video))" />
                  <vs-input class="w-3/4" label="视频地址" name="video" v-model="currentWork.video"></vs-input>
                  <span v-show="!checkMediaMp4" class="text-danger text-sm">请使用MP4后缀视频</span>
                  <vs-alert class="mt-4" color="warning" title="上传视频提示：">
                    <p>请输入或粘贴MP4视频格式地址至上方（例如：http://vjs.zencdn.net/v/oceans.mp4）。</p>
                    <p>如果没有上传视频的工具，可点击此处使用<b @click="activePrompt = true" class="text-primary cursor-pointer">视频上传助手小程序</b>。</p>
                  </vs-alert>
                  <vs-button v-if="match.isScratch" class="mt-4" iconPack="feather" icon="icon-upload-cloud" @click="submitWork">提交视频地址</vs-button>
                </div>
                <vs-divider class="px-4"/>
                <div class="ml-4" v-if="itemSche.status == 1 && !match.isScratch">
                  <vs-button color="success" iconPack="feather" icon="icon-upload" @click="submitWork">保存信息</vs-button>
                  <vs-alert title="提示" color="rgb(231, 154, 23)" icon-pack="feather" icon="icon-info" active="true" class="mt-4 text-warning">
                    请填写作品名称，上传文件后及视频后，点击保存信息。
                  </vs-alert>
                </div>
                
              </div>
            </tab-content>
            <template slot="footer" scope="props">
                <div class=wizard-footer-left>
                  <wizard-button  v-if="props.activeTabIndex > 0" :style="props.fillButtonStyle"  @click.native="props.prevTab()">上一个赛程</wizard-button>
                </div>
                <div class="wizard-footer-right">
                  <wizard-button v-if="!props.isLastStep" @click.native="props.nextTab()" class="wizard-footer-right" :style="props.fillButtonStyle">下一个赛程</wizard-button>
                </div>
              </template>
          </form-wizard>
        </vx-card>
      </div>
      <div class="vx-col w-full lg:w-1/4">
        <vx-card title="我的参赛信息" class="mt-base">
          <h4>参赛ID：{{ match.teamName }}</h4>
          <p class="mt-4">当前进度：{{ match.schedule[currentScheduleIndex].title }}</p>
          <p>已提交作品：{{ isUploadedWork }}</p>
          <p>已上传视频：{{ isUploadedVideo }}</p>
        </vx-card>
        <vx-card :title="match.type == 1?'已提交选手':'已提交作品团队'" class="mt-base">
          <!-- ACTION SLOT -->
          <template slot="actions">
            <feather-icon icon="MoreHorizontalIcon"></feather-icon>
          </template>

          <ul class="friend-suggesions-list" v-if="uploadedTeams.length > 0">
            <li
              class="friend-suggestion flex items-center mb-4"
              v-for="(teamItem, index) in uploadedTeams"
              :key="index"
            >
              <div class="mr-3" v-if="!match.type">
                <img class="w-24 h-16" v-if="teamItem.team_img" :src="teamItem.team_img" alt="team-img">
                <img class="w-24 h-16" v-else :src="require('@/assets/images/team/default_team.png')" alt="team-img">
              </div>
              <div class="mr-3" v-else>
                <vs-avatar class="m-0" v-if="teamItem.team_img" :src="teamItem.team_img" size="35px" />
                <vs-avatar class="m-0" v-else :src="require(`@/assets/images/profile/default-avatar.png`)" size="35px" />
              </div>
              <div class="leading-tight overflow-hidden truncate">
                <p class="font-medium truncate">{{ teamItem.team_name }}</p>
                <span class="text-xs"
                  >{{ teamItem.team_slogan }}</span
                >
              </div>
            </li>
          </ul>
          <div class="font-light text-lg" v-else>
            <p v-if="match.type == 1">
              还没有选手提交
            </p>
            <p v-else>
              还没有团队提交
            </p>
            
          </div>
          <template slot="footer" v-if="successTeamsTen.length > 0">
            <vs-button icon-pack="feather" icon="icon-plus" class="w-full"
              >查看更多</vs-button
            >
          </template>
        </vx-card>
      </div>
    </div>

    <!-- 未开始 -->
    <div class="vx-row" v-else-if="match.status == 2">
      <div class="vx-col w-full lg:w-3/4">
        <vx-card  title="我的报名信息" class="mt-base">
          <template v-if="match.isSubmit" slot="actions">
            <vs-chip v-if="match.isPass === 0" color="warning">
              <vs-avatar icon-pack="feather" icon="icon-more-horizontal" color="warning"/>
              审核中
            </vs-chip>
            <vs-chip v-else-if="match.isPass === 1" color="success">
              <vs-avatar icon-pack="feather" icon="icon-check" color="success" />
              已通过
            </vs-chip>
            <vs-chip v-else color="danger">
              <vs-avatar icon-pack="feather" icon="icon-x" color="danger" />
              未通过
            </vs-chip>
          </template>
          <div class="w-full lg:w-2/3 md:w-3/4 mx-auto">
            <p v-if="match.type != 1" class="text-center mb-4">提示：如果没有团队可选，请先在‘我的团队’中<span class="cursor-pointer" style="color:#6fa0fb" @click="toCreateTeam">创建团队</span></p>
            <k-form-build ref="signUpForm" :value="match.formTmp" :defaultValue="{}"/>
          </div>
          <div class="text-center flex justify-center">
            <vs-button v-if="!match.isSubmit" icon-pack="feather" icon="icon-user-check" color="success" @click="submitSignUp" :disabled="allowSignUpBtn">提交报名</vs-button>
            <div v-else>
              <vs-button v-if="match.isPass === 0" color="warning" icon-pack="feather" icon="icon-more-horizontal" icon-after disabled>审核中</vs-button>
              <vs-button v-else-if="match.isPass === 1" icon-pack="feather" icon="icon-check" color="success">审核已通过</vs-button>
              <div v-else>
                <vs-alert active="true" icon-pack="feather" icon="icon-alert-circle" color="danger" class="mb-4">{{ match.explain }}</vs-alert>
                <vs-button icon-pack="feather" icon="icon-edit" @click="updateSignUp" :disabled="allowSignUpBtn">提交修改</vs-button>
              </div>
              
            </div>
            
          </div>
        </vx-card>
      </div>
      <div class="vx-col w-full lg:w-1/4">
        <vx-card :title="match.type == 1?'最新报名选手':'最新报名团队'" class="mt-base">
          <!-- ACTION SLOT -->
          <template slot="actions">
            <feather-icon icon="MoreHorizontalIcon"></feather-icon>
          </template>

          <ul class="friend-suggesions-list" v-if="successTeamsTen.length > 0">
            <li
              class="friend-suggestion flex items-center mb-4"
              v-for="(teamItem, index) in successTeamsTen"
              :key="index"
            >
              <div class="mr-3" v-if="!match.type">
                <img class="w-24 h-16" v-if="teamItem.imgSrc" :src="teamItem.imgSrc" alt="team-img">
                <img class="w-24 h-16" v-else :src="require('@/assets/images/team/default_team.png')" alt="team-img">
              </div>
              <div class="mr-3" v-else>
                <vs-avatar class="m-0" v-if="teamItem.imgSrc" :src="teamItem.imgSrc" size="35px" />
                <vs-avatar class="m-0" v-else :src="require(`@/assets/images/profile/default-avatar.png`)" size="35px" />
              </div>
              <div class="leading-tight overflow-hidden truncate">
                <p class="font-medium truncate">{{ teamItem.name }}</p>
                <span class="text-xs" v-if="!match.type">{{ teamItem.slogan }}</span>
              </div>
            </li>
          </ul>
          <div class="font-light text-lg" v-else>
            <p v-if="match.type == 1">
              还没有人报名
            </p>
            <p v-else>
              还没有团队报名
            </p>
            
          </div>
          <template slot="footer" v-if="successTeamsTen.length > 0">
            <vs-button type="border" class="w-full"
              >已报名数量：{{ match.successTeamsCount }}</vs-button
            >
          </template>
        </vx-card>
      </div>
      
    </div>


    <!-- 已结束 -->
    <div class="vx-row" v-else-if="match.status == 4">
      <div class="vx-col w-full  mb-base">
        <vx-card v-if="match.matchResult"
            slot="no-body"
            class="text-center bg-primary-gradient greet-user"
          >
          <img
            :src="require('@/assets/images/elements/decore-left.png')"
            class="decore-left"
            alt="Decore Left"
            width="200"
          />
          <img
            :src="require('@/assets/images/elements/decore-right.png')"
            class="decore-right"
            alt="Decore Right"
            width="175"
          />
          <feather-icon
            icon="AwardIcon"
            class="p-6 mb-8 bg-primary inline-flex rounded-full text-white shadow"
            svgClasses="h-8 w-8"
          ></feather-icon>
          <h1 class="mb-6 text-white">恭喜你{{ match.type === 0 ? '的团队':'' }}“{{ match.teamName }}”在该比赛中获得 <i>{{ match.matchResult }}</i> 的好成绩！</h1>
          <p class="text-white mt-5">Congratulations !</p>
        </vx-card>
      </div>
      
    </div>

    <vs-prompt
      vs-title="视频上传说明"
      vs-accept-text="好的，我已经上传。"
      vs-cancel-text="知道了。"
      :vs-active.sync="activePrompt"
      @vs-accept="acceptReload"
    >
      <p class="text-lg px-4">请用微信扫描下面二维码，在打开的小程序上传视频。</p>
      <div class="w-full flex justify-center mt-4">
        <!-- <img class="md:w-1/3" src="http://match.klmm.xyz/uploads/2020-10-21/092b38811d6ce8d9fab85e793ad00810.png"> -->
        <qrcode :value="videoQrcode" :options="{ width: 200 }"></qrcode>
      </div>
      
    </vs-prompt>
  </div>
</template>

<script>

import {FormWizard, TabContent, WizardButton} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import UploadFile from '@/components/upload/UploadFile'

import VueQrcode from '@chenfengyuan/vue-qrcode'

import config from '@/config'
import { detail, postSignUpData, updateSignUpData, getUploadedTeams, workUpload } from '@/api/match'
import { getToken } from '@/utils/tools'
import { videoPlayer } from 'vue-video-player'
import 'video.js/dist/video-js.css'

export default {
  data() {
    return {
      match: [],
      successTeamsTen: [], // 报名成功的团队
      uploadedTeams: [], // 已上传作品的团队
      signUpData: [], // 报名后的数据
      currentScheduleIndex: 0, // 当前赛程索引
      currentWork: false,
      waitSubmitWork: {
        'fileSrc': '',
        'fileName': '',
        'video': '',
      },
      isWaitWorkTitle: false,
      activePrompt: false,
      mediaExtensions: { img: ['jpg', 'jpeg', 'png', 'bmp', 'gif', 'exif', 'tiff'], video: ['avi', 'flv', 'wmv', 'mov', 'mp4', '3gp'] },
      media: { sources: [{ type: "video/mp4", src: "http://vjs.zencdn.net/v/oceans.mp4" }]},
      allowSignUpBtn: false,
      videoQrcode: '',
    };
  },
  computed: {
    setReuploadFileName() {
      let fileName = this.waitSubmitWork.fileSrc, ext
      if (fileName) {
        ext = fileName.substring(fileName.lastIndexOf('.') + 1)
      } else {
        return ''
      }
      return `${this.waitSubmitWork.fileName}.${ext}`
    },
    playerOptions() {
      return (media) => {
          return {
              height: '360',
              fluid: true,
              autoplay: false,
              muted: true,
              language: 'en',
              playbackRates: [0.7, 1.0, 1.5, 2.0],
              sources: media.sources,
          }
      }
    },
    isUploadedWork() {
      return this.currentWork?'是':'否'
    },
    isUploadedVideo() {
      return this.currentWork && this.currentWork.video?'是':'否'
    },
    checkMediaMp4() {
      if (!this.currentWork.video) {
        return false
      } else if (this.currentWork.video.substring(this.currentWork.video.lastIndexOf('.')).toLowerCase() !== '.mp4') {
        return false
      }
      return true
    }
  },
  methods: {
    acceptReload() {
      this.getMatchDetail(this.$route.query.id)
    },
    setMedia(src) {
      this.media.sources[0].src = src
      return this.media
    },
    isLastStep() {
      if (this.$refs.wizard) {
        return this.$refs.wizard.isLastStep
      }
      return false
    },
    goToScratch(type) {
      // 设置当前团队及赛程到工具端，方便获取
      localStorage.setItem('currentSid', this.match.schedule[this.currentScheduleIndex].id) // 设置赛程id
      localStorage.setItem('currentTid', this.match.teamId) // 设置团队id
      if (type) {
        window.open(`${config.matchHost}scratch/?edit#${this.currentWork.id}`)
      } else {
        window.open(`${config.matchHost}scratch/`)
      }
    },
    openLoading(type){
      if (type) {
        this.$vs.loading({
          text:'努力加载中...'
        })
      } else {
        this.$vs.loading.close()
      }
    },
    getUploadResult(payload) {
      this.waitSubmitWork.fileSrc = payload
    },
    submitWork(){
      let that = this
      if (!that.waitSubmitWork.fileName) {
        that.isWaitWorkTitle = true
        return false
      } else if (!that.waitSubmitWork.fileSrc) {
        that.$vs.notify({
          color: 'warning',
          title: '作品提示',
          text: '请上传作品！',
          iconPack: 'feather',
          icon:'icon-alert-circle'
        })
        return false
      }
      that.isWaitWorkTitle = false
      if (!that.checkMediaMp4) {
        that.$vs.notify({
          color: 'warning',
          title: '视频提示',
          text: '请上传正确的视频地址后再提交',
          iconPack: 'feather',
          icon:'icon-alert-circle'
        })
        return false
      }
      that.waitSubmitWork.video = that.currentWork.video
      let obj = Object.assign({
        access_token: getToken(),
        teamId: that.match.teamId,
        scheduleId: that.match.schedule[that.currentScheduleIndex].id
      }, that.waitSubmitWork)
      workUpload(obj).then((res) => {
        console.log(res)
        if (res.data.err_code === 0) {
          that.$vs.notify({
            color: 'success',
            title: '作品提示',
            text: '作品提交成功啦～',
            iconPack: 'feather',
            icon:'icon-alert-circle'
          })
          setTimeout(() => {
            that.acceptReload()
          }, 1500)
        }
      })
    },
    formSubmitted(res) {
      console.log(res)
    },
    generateQrcode(scheduleId, teamId) {
      let host = window.location.host
      let url = `https://${host}/scan?access_token=${getToken()}&scheduleId=${scheduleId}&teamId=${teamId}`
      this.videoQrcode = url
    },
    getMatchDetail(id) {
      let that = this
      detail({
        access_token: getToken(),
        matchId: id
      }).then((res) => {
        if (res.data.info.id !== undefined) {
          that.match = res.data.info
          that.currentScheduleIndex = that.match.currentScheduleIndex
          that.successTeamsTen = res.data.info.successTeamsTen
          if (that.match.status === 3) {
            that.currentWork = that.match.schedule[that.currentScheduleIndex].teamWork
            if (that.currentWork) {
              that.waitSubmitWork.fileSrc = that.currentWork.file_src
              that.waitSubmitWork.fileName = that.currentWork.file_name
              that.waitSubmitWork.video = that.currentWork.video
            }
            that.generateQrcode(that.match.schedule[that.currentScheduleIndex].id, res.data.info.teamId)
            that.getUploadedList(that.match.schedule[0].id)
          }
          if (res.data.info.signUpData !== undefined) {
            that.signUpData = res.data.info.signUpData
          }
          that.openLoading(false)
        } else {
          that.$router.push('/pages/error-404')
        }
        
      })
    },
    submitSignUp() {
      let that = this
      that.$refs.signUpForm.getData().then(values => {
        that.allowSignUpBtn = true
        postSignUpData({
          access_token: getToken(),
          matchId: that.match.id,
          formTmpId: that.match.formTmpId,
          formData: JSON.stringify(values)
        }).then(res => {
          if (res.data.err_code == 0) {
            that.$vs.notify({
              color: 'success',
              title: '报名成功',
              text: '报名成功啦～',
              iconPack: 'feather',
              icon:'icon-alert-circle'
            })
            setTimeout(() => {
              that.$router.push({path: '/match/list', query:{tabsIndex: 1}})
            }, 1500)
          } else {
            setTimeout(() => {
              that.allowSignUpBtn = false
            }, 1500)
          }
        })
      })
    },
    updateSignUp() {
      let that = this
      that.$refs.signUpForm.getData().then(values => {
        updateSignUpData({
          access_token: getToken(),
          matchId: that.match.id,
          signUpId: that.match.signUpId,
          formData: JSON.stringify(values)
        }).then(res => {
          if (res.data.err_code == 0) {
            that.$vs.notify({
              color: 'success',
              title: '修改成功',
              text: '修改成功，请耐心等待审核喔～',
              iconPack: 'feather',
              icon:'icon-alert-circle'
            })
            setTimeout(() => {
              that.$router.push({path: '/match/list', query:{tabsIndex: 1}})
            }, 1500)
          } else {
            setTimeout(() => {
              that.allowSignUpBtn = false
            }, 1500);
          }
        })
      })
    },
    getUploadedList(id) {
      let that = this
      getUploadedTeams({
        access_token: getToken(),
        scheduleId: id,
        number: 10,
      }).then((res) => {
        if (res.data.err_code === 0) {
          that.uploadedTeams = res.data.list
        } 
        
      })
    },
    goToMatchDetail(url) {
      window.open(url);
    },
    toCreateTeam() {
      this.$router.push({path: '/team/create-list', query: {ref: this.$route.fullPath}})
    }
  },
  components: {
    FormWizard,
    TabContent,
    WizardButton,
    UploadFile,
    videoPlayer,
    'qrcode': VueQrcode
  },
  created() {
    this.openLoading(true)
    let tab = this.$route.query.tab, tabsIndex = this.$route.query.tabsIndex
    if (tab != undefined && tabsIndex != undefined) {
      this.$route.meta.breadcrumb[1].title = `我的赛事 - ${tab}`
      this.$route.meta.breadcrumb[1].url = `/match/list?tabsIndex=${tabsIndex}`
    }
    this.getMatchDetail(this.$route.query.id)
  },
  mounted() {
  },
  updated() {
    if (this.signUpData.length != 0) {
      this.$refs.signUpForm.setData(this.signUpData)
    }
    
  }
};
</script>

<style lang="scss">
#profile-page .profile-header-nav {
    background-color: #fff;
}
.greet-user {
    position: relative;
    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }
    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
</style>
